module.exports = {"apiUrl":"https://api.ratoab.se","siteUrl":"https://ratoab.se"};